import Link from "next/link";
import InlineButton, { InlineButtonProps } from "./inline-button";
import { FaCheck } from "react-icons/fa6";
import React from "react";
import { cn } from "@/lib/utils";

export interface TextCardListedProps {
  className?: string;
  href?: string;
  title: string;
  items?: string | string[];
  children?: React.ReactNode;
  button?: InlineButtonProps;
}

const TextCardListed: React.FC<TextCardListedProps> = ({
  className,
  href = "#",
  title = "Card Title",
  items,
  children,
  button = {
    color: "teal",
    children: "Learn More",
  },
}) => {
  const itemList =
    typeof items === "string"
      ? items.split(",").filter((x) => Boolean(x))
      : items;
  return (
    <Link
      href={href}
      className={cn(
        "flex w-full flex-col gap-2 rounded-2xl border border-secondary-300 bg-white p-3 md:p-4 lg:gap-4 lg:rounded-[20px] lg:p-6",
        "shadow-[4px_6px_20px_2px_rgba(0,65,66,0.14)]",
        "hover:border-primary-300 hover:bg-primary-100 hover:shadow-none",
        "transition ease-out",
        className
      )}
    >
      <div className="flex flex-col gap-2 lg:gap-4">
        <div
          className={cn(
            "font-montserrat text-subheading-3-500 text-secondary-500 lg:text-subheading-2"
          )}
        >
          {title}
        </div>
        {itemList && itemList.length > 0 && (
          <ul className="grid grid-cols-1 gap-2">
            {itemList?.map((item, index) => (
              <li
                key={`${item}-${index}`}
                className="flex flex-row items-center gap-2 font-roboto text-body-1-300 text-neutral-500"
              >
                <FaCheck
                  className="text-primary-400"
                  size={20}
                />
                {item}
              </li>
            ))}
          </ul>
        )}
        <div className="flex flex-row items-center gap-1 font-roboto text-body-1-300 text-neutral-500">
          {typeof children === "string" ? (
            <div
              className="rich-text [&_a]:hover:text-primary-700 [&_a]:focus:text-primary-700 line-clamp-6 overflow-ellipsis [&_a]:rounded-md [&_a]:font-roboto [&_a]:text-body-1-400 [&_a]:text-primary-600 [&_a]:underline [&_a]:underline-offset-2 [&_a]:hover:no-underline [&_a]:focus:no-underline [&_a]:focus:outline [&_a]:focus:outline-1 [&_a]:focus:outline-offset-2 [&_a]:focus:outline-black"
              dangerouslySetInnerHTML={{ __html: children || "" }}
            />
          ) : (
            <div className="line-clamp-6 overflow-ellipsis">{children}</div>
          )}
        </div>
      </div>
      {button && (
        <InlineButton
          {...button}
          size="md"
          className={cn(button.className)}
        />
      )}
    </Link>
  );
};

export default TextCardListed;
